import { Component, Inject, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { GameSettingsService } from '../../game-settings.service';
import emojiRegex from 'emoji-regex';
@Component({
  selector: 'custom-count',
  templateUrl: './custom-count.component.html',
  styleUrls: ['./custom-count.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomCountComponent implements OnInit {

  countImage: any = {
    file: null,
    img: null,
    isExpand: false,
  };
  emojiImage: any = null;
  dialogTitle: string = '';

  s3BucketUrl: string = environment.s3BucketUrl;

  dataToBeAnimate: any[] = [];
  current: number;
  isCounterHidden = false;
  isFinalVisible = false;
  isScaleUp = false;
  count: number = 0;
  emojis: any[] = [];
  type: any = null;
  index: number = 0;

  textAreaInput: string | null = null;
  inputError: string | null = null;

  animationInterval = null;

  countdownArray: string[] = [];

  constructor(public dialogRef: MatDialogRef<CustomCountComponent>,
    public gameSettingsService: GameSettingsService,
    @Inject(MAT_DIALOG_DATA) private data: any, private domSanitizer: DomSanitizer) { 
      this.textAreaInput = data.textAreaInput
      this.dialogTitle = data.title;
      this.count = data.count;
      this.emojiImage = data.emojiImage;
      this.emojis = data.emojis;
      this.type = data.type;
      this.countImage.img = data.countImage ? data.countImage : 
        this.gameSettingsService.defaultCoinIcon !== null && 
          this.gameSettingsService.defaultCoinIcon.value ? 
            this.gameSettingsService.defaultCoinIcon.value : '';
      this.countImage.isExpand = data.isExpand;
      this.index = data.index;
  }

  ngOnInit() {
    if (this.type === 'count') {
      this.textAreaInput = this.textAreaInput ? this.textAreaInput : this.generateSpans(); 
      this.dataToBeAnimate = this.textAreaInput 
        ? this.textAreaInput.match(/<span>(\d+)<\/span>/g).map(match => +match.replace(/<\/?span>/g, '')) : [];
      this.initializeAnimationCountArray(false);
    } else {
      this.initializeAnimationCountArray(false);
      this.textAreaInput = this.generateSpans(); 
    }
    this.runAnimation();
    
  }

  uploadImage($event) {
    if ($event && $event.target && $event.target.files.length !== 0) {
      let file = $event.target.files[0];
      this.countImage.file = file;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.countImage.img = this.sanitizeUrl(reader.result);
      };
    }
  }

  onInputValueChange(newValue: string) {
    if (this.isValidInput(newValue)) {
      // Handle valid input
      this.inputError = null;
    }
  }

  private isNumber(arr: any[]): boolean {
    return arr.every(item => typeof item === 'number' && !isNaN(item));
  }

  isValidInput(input: string): boolean {
    if (this.type === 'count') {
      const spanRegex = /<span>([^<>]+)<\/span>/g;
      const matches = input.match(spanRegex);

      if (!matches) {
        this.inputError = `Please enter numbers or emojis inside <span> tags.`;
        return false;
      }

      const extractedValues = matches.map(function(match) {
        return match.replace(/<\/?span>/g, '').trim();
      });

      const isValid = extractedValues.every(function(value) {
        var isNumber = /^\d+$/.test(value);
        var isEmoji = /^[\u203C-\u3299\uD83C-\uDBFF\uDC00-\uDFFF]+$/.test(value);
        return isNumber || isEmoji;
      });

      if (!isValid) {
        this.inputError = `Only numbers or emojis are allowed inside <span> tags.`;
        return false;
      }

      this.countdownArray = extractedValues;

      this.textAreaInput = input;
      this.dataToBeAnimate = this.countdownArray;
      this.count = this.countdownArray.length;
      this.resetDOM();
      this.runAnimation();

      return true;
    }
    else {
        const regex = /^<span>(?:[^<]+)<\/span>(?:<span>(?:[^<]+)<\/span>)*$/;
        if (regex.test(input)) {
          const extractEmojiRegex = emojiRegex();
          const emojis = input.match(extractEmojiRegex) || [];
          this.updateDataToBeAnimate(emojis);
          return true;
        }
        this.inputError = `Please enter an emoji between <span> tags.`;
        return false;
     }
  }

  updateDataToBeAnimate(emojis: string[]) {
    this.dataToBeAnimate = emojis;
    this.emojis = emojis;
    this.count = emojis.length;
    // Additional logic to handle the updated dataToBeAnimate array
    this.replayAnimation(false);
  }

  sanitizeUrl(url): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  isSafeUrl(url: any): boolean {
    let URL = url && url.changingThisBreaksApplicationSecurity ? url.changingThisBreaksApplicationSecurity : url;
    return URL ? URL.includes('data:image') : false;
  }

  resetDOM() {
    this.isCounterHidden = false;
    this.isFinalVisible = false;
    this.isScaleUp = false;
    this.current = undefined;
  }

  runAnimation() {
    // Clear any existing interval if present
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  
    this.current = this.dataToBeAnimate[0];
    let idx = 1;
    this.animationInterval = setInterval(() => {
      if (idx < this.dataToBeAnimate.length) {
        this.current = this.dataToBeAnimate[idx];
        idx++;
      } else {
        clearInterval(this.animationInterval);
        setTimeout(() => {
          this.isCounterHidden = true;
          this.isFinalVisible = true;
          setTimeout(() => {
            this.isScaleUp = true;
          }, 200);
        }, 200);
      }
    }, 1000);
  }

  replayAnimation(fromUpdateCount) {
    this.initializeAnimationCountArray(fromUpdateCount);
    this.resetDOM();
    this.runAnimation();
  }

  initializeAnimationCountArray(fromUpdateCount: boolean) {
    if (this.type === 'count') {

      if (fromUpdateCount) {

        // Check if all values are numbers
        var isAllNumbers = this.countdownArray &&
          this.countdownArray.every(function (value: string) {
            return /^\d+$/.test(value);
          });

        if (isAllNumbers) {
          // Generate numeric countdown
          this.dataToBeAnimate = Array.from(
            { length: this.count },
            function (_, index) {
              return this.count - index;
            }.bind(this)
          );
        } else {
          // Emoji or mixed mode → use as-is
          this.dataToBeAnimate = this.countdownArray;
        }

      } else {
        this.dataToBeAnimate = this.countdownArray;
      }

    } else {
      this.dataToBeAnimate = this.emojis;
    }
  }


  updateCount(value: string) {
    const parsedCount = parseInt(value, 10);
    this.count = isNaN(parsedCount) ? 0 : parsedCount;
    this.textAreaInput = this.generateSpans();
    if (this.type === 'emoji') {
      const extractEmojiRegex = emojiRegex();
      const emojis = this.textAreaInput.match(extractEmojiRegex) || [];
      this.dataToBeAnimate = emojis;
      this.emojis = emojis;
      this.resetDOM();
      this.runAnimation();
    } else {
      this.replayAnimation(true);
    }
  }

  // * working fine just not reanimating emojis
  private emojiSpans: string[] = [];

  generateSpans(): string {
    if (this.count <= 0) {
      return '';
    }
  
    if (this.type === 'count') {
      const spans = Array.from({ length: this.count }, (_, index) => `<span>${this.count - index}</span>`);
      return spans.join('');
    }

    if (this.type === 'emoji') {
      if (this.emojiSpans.length === 0) {
        let dataCount = 0;
        if (this.dataToBeAnimate && this.dataToBeAnimate.length !== 0) {
          dataCount = this.dataToBeAnimate.length;
        } else if (this.emojis && this.emojis.length !== 0) {
          dataCount = this.emojis.length;
        }
        this.emojiSpans = this.generateEmojiSpans(this.count - dataCount);
      } else if (this.count > this.emojiSpans.length) {
        let count = this.count - this.emojiSpans.length;
        this.emojiSpans = this.emojiSpans.concat(this.generateEmojiSpans(count));
      } else if (this.count < this.emojiSpans.length) {
        this.emojiSpans = this.emojiSpans.slice(0, this.count);
      }
  
      return this.emojiSpans.join('');
    }
  
    return '';
  }
  
  private generateEmojiSpans(count: number): string[] {
    let generatedSpans: string[] = [];
  
    if (this.dataToBeAnimate.length !== 0) {
      generatedSpans.push(...this.dataToBeAnimate.map((emoji: string) => `<span>${emoji}</span>`));
      if (count > 0) {
        generatedSpans = Array.from({ length: count }, () => `<span>${this.getRandomUnicodeEmoji()}</span>`);
      }
    } else {
      generatedSpans.push(...Array.from({ length: count }, () => `<span>${this.getRandomUnicodeEmoji()}</span>`));
    }
  
    return generatedSpans;
  }

  getRandomUnicodeEmoji() {
    const randomCodePoint = 0x1F600 + Math.floor(Math.random() * 0x50); // There are 0x50 (80) emojis in the range
    return String.fromCodePoint(randomCodePoint);
  }
}
